import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useMemo } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ProcessMonitoringStatus } from '../ProcessMonitoringStatus';
import strings from '../../Globalization';
import { getTranslation } from '../endosystemcycleinfoviews/CriticalParametersTable';
import { useAdvantageCycleInfo } from './Context';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0
	}
}));

const CollapsableRow = ({ row }) => {
	const [open, setOpen] = React.useState(false);
	const { groupItems } = row;
	const ornament = useMemo(() => open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>, [open]);
	return (
		<>
			<CustomTableRow row={row} customProps={{ onClick : () => setOpen(!open), style: { cursor: 'pointer' }}} ornament={ornament} />
			{open && groupItems.map((row, index) => {
				return <CustomTableRow row={row} key={`groupedRow-${index}`} />
			})
			}
		</>
	);
}

const CustomTableRow = ({ row = {}, customProps, ornament, index }) => {
	const { HeaderLabel, UnitHeader, Metric, Actual, ColSpan = 1, CriticalParameterIcon, Index, TabHeader, isTitle, type, customIcon } = row;
	const formattedString = isTitle ? HeaderLabel : getTranslation(HeaderLabel);
	return (
		<StyledTableRow {...customProps}>
			<TableCell key={`row-${index}-HeaderLabel`} colSpan={ColSpan} variant={isTitle ? 'head' : 'body'} >
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					{TabHeader && <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>}
					{`${formattedString}${UnitHeader ? ` (${UnitHeader})` : ''} ${Index || ''}`}
					{type === 'group' && ornament}
				</Box>
			</TableCell>
			<TableCell key={`row-${index}-MetricDataProperty1`}>{strings[Metric] || Metric}</TableCell>
			<TableCell key={`row-${index}-ActualDataProperty1`}>{strings[Actual] || Actual}</TableCell>
			<TableCell key={`row-${index}-CriticalParameterIcon`}>
				<ProcessMonitoringStatus CriticalParameterIcon={CriticalParameterIcon} customIcon={customIcon} />
			</TableCell>
		</StyledTableRow>
	);
}

const CriticalParametersTable = () => {

	const { data } = useAdvantageCycleInfo();
	const columns = [
		{ name: 'HeaderLabel', label: strings.Parameter, colSpan: 2 },
		{ name: 'MetricDataProperty1', label: strings.Metric },
		{ name: 'ActualDataProperty1', label: strings.Actual },
		{ name: 'CriticalParameterIcon', label: strings.CriticalParamenterTitle }
	];

	const rows = data.CriticalParameters;

	return (
		<TableContainer component={Box}>
			<Table size="small" aria-label="critical parameters table">
				<TableHead>
					<TableRow>
						{columns.map(({ label, ...thProps }, index) => (
							<TableCell {...thProps} key={`column-${index}`}>
								{label}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{rows?.length > 0 ? (
						rows.map((row, index) => {
							const { type } = row;
							return (type === 'group') ?
								<CollapsableRow
									key={`row-${index}`}
									row={row}
								/> :
								<CustomTableRow key={`row-${index}`} row={row} index={index} />
						})
					) : (
						<TableRow>
							<TableCell colspan={columns.length} align="center" colSpan={5}>
								{strings.Empty}
							</TableCell>
						</TableRow>
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
export default CriticalParametersTable;
